import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageBox } from '@account-services-mfe/core';
import useGetImages from '../../../../../hooks/use-get-images';
import { ScreenWrapper } from '../subcomponents';
import { DebtCancellationContainer, Image, SuccessMessageContainer, TitleContainer } from './subcomponents';
import triggerPaymentSecurityAnalytics from '../../../../../helpers/trigger-payment-security-analytics';
import { PAGE_NAME } from '../../../../../const/analytics';
import MessageBoxContainer from '../../../../common/MessageBoxContainer';
const EnrollmentSuccess = () => {
    const { t } = useTranslation();
    const { spotCardSecurity } = useGetImages();
    useEffect(() => {
        triggerPaymentSecurityAnalytics({
            pageName: PAGE_NAME.COMPLETE_PROCESSING
        });
    }, []);
    return (_jsxs(ScreenWrapper, { children: [_jsx(MessageBoxContainer, { children: _jsx(MessageBox, { type: "info", messageDescription: t('enrollmentSuccess.chargesStatement') }) }), _jsxs(SuccessMessageContainer, { id: "ps-pending-enrollment", "data-cy": "status-message-container", top: "xxlarge", bottom: "large", children: [_jsx(Image, { src: spotCardSecurity, alt: "enrollment-success-image" }), _jsx(Inset, { horizontal: "large", children: _jsx(Inset, { top: "small", hideOnBreakpointDown: "small", children: _jsx(TitleContainer, { weight: "bold", children: t('enrollmentSuccess.thanksForPurchasing') }) }) }), _jsx(Body, { children: t('enrollmentSuccess.requestOnProcess') }), _jsx(DebtCancellationContainer, { hideBottomSpace: true })] })] }));
};
export default EnrollmentSuccess;
